import TimelineElement from './Timeline'
import Item from './TimelineItem'

import './style/css'

const Timeline = Object.assign(TimelineElement, { Item })

export default Timeline
